module.exports = __webpack_public_path__ + "static/media/passengers.15f4765e.svg";